<ng-container *ngFor="let faq of faqs; let i = index">
  <app-faqs-item
    [x]="i"
    [y]="1"
    [faq]="faq"
    (emitOnEnterPressed)="emitOnEnter($event)">
  </app-faqs-item>
</ng-container>


